
















import Vue from 'vue'
import PageDefaultLayout from '@/components/globals/PageDefaultLayout.vue'
import Notifications from '@/components/notification/Notifications.vue'
import {
  Notification,
  listNotifications,
  markNotificationsAsRead,
} from '@/core/Notifications'
import { Meta } from '@/tools/page'

const PAGE_TITLE = 'お知らせ'
const PAGE_META: Meta[] = []

export default Vue.extend({
  components: {
    PageDefaultLayout,
    Notifications,
  },
  data() {
    return {
      notifications: [] as Notification[],
      loading: false,
    }
  },
  watch: {
    $route: 'fetchData',
  },
  created() {
    this.$setPageTitle(PAGE_TITLE)
    this.$setPageMeta(PAGE_META)
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      const notifications = await listNotifications()
      this.notifications = notifications

      // お知らせを既読にする
      markNotificationsAsRead(this.notifications.map(({ id }) => id))

      this.loading = false
    },
  },
})
